export default __webpack_public_path__ + "static/media/favicon-16x16.4bf13b48.png";